<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      :title="processException.pkid > 0 ?'编辑':'新建'"
      class="processException-edit"
      width="1200px"
      top="2vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="processException"
        :rules="ruleValidate"
        class="form"
        label-width="160px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="异常信息登记" name="first">
          <div class="vm-separate">
            <el-form-item label="系统编号">
              <el-input v-model="processException.billNo" disabled/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="开单人">
              <el-input v-model="processException.creatorName" disabled/>
            </el-form-item>
            <el-form-item label="登记日期">
              <el-input v-model="processException.createTime" disabled/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="反馈部门">
              <el-select v-model="processException.feedbackDepart" clearable placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="反馈人">
              <el-input v-model="processException.feedbackPerson"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="出厂编号" prop="factoryNo">
              <el-input v-model="processException.factoryNo" @change="getCustomerName"/>
            </el-form-item>
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="processException.customerName" clearable>
                <el-button slot="append" @click="$refs.customerSelect.open()"> 选择</el-button>
              </el-input>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="物料号" prop="materialNo">
              <el-input v-model="processException.materialNo" @change="selectNameByNo"/>
            </el-form-item>
            <el-form-item label="物料描述">
              <el-input v-model="processException.materialName"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="当批总数">
              <el-input v-model="processException.batchNum"/>
            </el-form-item>
            <el-form-item label="不良数量">
              <el-input v-model="processException.badNum"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="误工工时">
              <el-input v-model="processException.workTime"/>
            </el-form-item>
            <el-form-item label="一体机/板卡序列号">
              <el-input v-model="processException.serialNo"/>
            </el-form-item>
          </div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 14px;margin-top: 20px">
            问题描述
          </div>

          <div class="vm-separate">
            <el-form-item label="基准：">
              <el-input v-model="processException.standards" type="textarea"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="实际" prop="problemDesc">
              <el-input v-model="processException.problemDesc" type="textarea"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="备注">
              <el-input v-model="processException.note" type="textarea"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="是否需要对当前问题处理">
              <el-select v-model="processException.isHandle">
                <el-option :value="false" label="否"/>
                <el-option :value="true" label="是"/>
              </el-select>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item v-if="processException.isHandle" label="处理部门接口人" prop="handleName">
              <el-input v-model="processException.handleName" clearable placeholder="请选择处理部门接口人">
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
              </el-input>
              <user-select ref="selectHandle" @select="selectHandle"/>
            </el-form-item>
            <el-form-item label="质量部接口人" prop="qualityDirecterName">
              <el-select v-model="processException.qualityDirecterName" clearable placeholder="请选择">
                <el-option
                    v-for="item in qualityUserList"
                    :key="item.systemUserID"
                    :label="item.employeeName"
                    :value="item.systemUserID"
                    @click.native="selectQualityDirecterName(item)"/>
              </el-select>
            </el-form-item>
          </div>

          <div>
            <div style="padding: 0 0 10px 10px;margin: 0 auto">
              <div>
                <el-form
                    ref="formUplosd"
                    enctype="multipart/form-data"
                    label-position="right"
                    label-width="120px"
                    size="mini">
                  <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
                    <div>
                      <div v-if="!processException.accessories || !processException.accessories.length">暂无附件</div>
                      <table width="100%">
                        <tr v-for="(item, index) in processException.accessories" :key="index">
                          <td>附件{{index + 1}}</td>
                          <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">
                            {{item.fileName}}
                          </td>
                          <td style="padding:5px">
                            <el-input v-model="item.note" size="mini"/>
                          </td>
                          <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <el-upload
                          action=""
                          multiple
                          :http-request="submitUpload"
                          :show-file-list="false"
                          :disabled="uploadLoading"
                          style="display: inline-block; float: right; margin: 5px;">
                        <el-button type="primary" plain>
                          <i class="el-icon-upload el-icon--right"/>
                          不良照片上传
                        </el-button>
                      </el-upload>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
          <!--          <div>-->
          <!--            <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单物料</div>-->
          <!--            <div style="padding: 0 0 10px 10px;margin: 0 auto">-->
          <!--              <div slot="toolbar">-->
          <!--                <el-button type="primary" style="margin-bottom: 10px" @click="$refs.materialSelect.open()">添加</el-button>-->
          <!--              </div>-->
          <!--              <el-table :data="processException.processExceptionMaterialVOS">-->
          <!--                <el-table-column label="物料编号" align="center" prop="materialNo"/>-->
          <!--                <el-table-column label="物料描述" align="center" prop="materialName"/>-->
          <!--                <el-table-column label="操作" align="center" width="80">-->
          <!--                  <template slot-scope="scope">-->
          <!--                    <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>-->
          <!--                  </template>-->
          <!--                </el-table-column>-->
          <!--              </el-table>-->
          <!--            </div>-->
          <!--          </div>-->
        </el-tab-pane>
        <el-tab-pane label="处理部门处理" name="second">
          <el-row>
            <el-col :span="8">
              <el-form-item label="不合格品处理方式">
                <el-select v-model="processException.processMode">
                  <el-option value="维修返工" label="维修返工"/>
                  <el-option value="退货" label="退货"/>
                  <el-option value="挑选" label="挑选"/>
                  <el-option value="让步接收(特批)" label="让步接收(特批)"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="质量判责" name="third">
          <el-form-item label="质量判责结果">
            <el-input v-model="processException.judgmentResult" type="textarea"/>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="责任部门">
                <el-input v-model="processException.responsibleDepartment" readonly placeholder="请选择责任部门">
                  <el-button slot="append" @click="$refs.departmentSelect.open()">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="责任部门接口人">
                <el-input v-model="processException.responsibleName" readonly placeholder="请选择责任部门接口人">
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectResponsible.open()"/>
                </el-input>
                <user-select ref="selectResponsible" @select="selectResponsible"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="供应商名称">
                <el-input v-model="processException.supplierName" readonly placeholder="请选择供应商">
                  <el-button slot="append" @click="$refs.supplierSelect.open()">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="开单人确认" name="fourth">
          <el-row>
            <el-col :span="8">
              <el-form-item label="问题是否已处理">
                <el-select v-model="processException.isHandle">
                  <el-option :value="0" label="否"/>
                  <el-option :value="1" label="是"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane> -->
      </el-tabs>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button v-if="processException.status!=5" type="primary" :loading="saveLoading" @click="handleSave">保存</el-button>
      <el-button v-if="processException.isHandle && processException.status!=5" type="warning" :loading="submitLoading" @click="handleSubmit">
        提交
      </el-button>
      <el-button v-if="processException.status == 5" type="primary" :loading="saveLoading" @click="handleSaveByBack">提交</el-button>
    </div>
    <material-select ref="materialSelect" @select="addMaterial"/>
    <customer-select ref="customerSelect" @select="customerAdd"/>
    <supplier-select ref="supplierSelect" @select="supplierSelect"/>
    <department-select ref="departmentSelect" @select="departmentSelect"/>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import MaterialSelect from "@/views/information/MaterialManagement/MaterialManagementSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierManageSelect";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

  export default {
    name: "ProcessExceptionEdit",
    components: {MaterialSelect, CustomerSelect, SupplierSelect, DepartmentSelect, UserSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        uploadLoading: false,
        saveLoading: false,
        submitLoading: false,
        activeName: "first",
        options: [
          {
            value: "电气生产部",
            label: "电气生产部",
          },
          {
            value: "部件生产部",
            label: "部件生产部",
          },
          {
            value: "发运部",
            label: "发运部",
          },
          {
            value: "仓储部",
            label: "仓储部",
          },
          {
            value: "线缆生产部",
            label: "线缆生产部",
          },
          {
            value: "其他",
            label: "其他",
          },
        ],
        feedbackDepart: [],
        qualityUserList: [
          {systemUserID: "1360", employeeName: "徐伟"},
          {systemUserID: "1523", employeeName: "陈栋良"},
          {systemUserID: "3826", employeeName: "张辉"},
        ],
        processException: {
          pkid: 0,
          billNo: "",
          createTime: "",
          customerName: "",
          feedbackDepart: "",
          factoryNo: "",
          department: loginUtil.getDepartmentName(),
          customerId: "",
          qualityDirecterId: "",
          qualityDirecterName: "",
          handleId: "",
          processMode: "",
          problemDesc: "",
          workTime: "",
          isHandle: true,
          serialNo: "",
          handleName: "",
          supplierName: "",
          responsibleDepartment: "",
          judgmentResult: "",
          batchNum: 1,
          badNum: 1,
          materialNo: "",
          materialName: "",
          creatorName: loginUtil.getName(),
          processExceptionMaterialVOS: [],
          accessories: [],
        },
        ruleValidate: {},
      };
    },
    mounted() {
    },
    methods: {
      open(id) {
        console.log(id);
        this.dialogVisible = true;
        this.processException.pkid = id;
        if (id > 0) {
          this.getData();
        } else {
          this.getSelectNo();
          this.getFormatDate(new Date());
        }
      },
      getData() {
        this.$http.get("basic", `processExceptions/${this.processException.pkid}`).then((res) => {
          console.log(res);
          this.processException = res;
          this.feedbackDepart = this.processException.feedbackDepart.split("/");
        });
      },
      getSelectNo() {
        this.$http.get("basic", "processExceptions/selectNo").then((res) => {
          this.processException.billNo = res;
        });
      },
      selectQualityDirecterName(item) {
        this.processException.qualityDirecterId = item.systemUserID;
        this.processException.qualityDirecterName = item.employeeName;
      },
      handleChange(value) {
        console.log(value);
        this.processException.feedbackDepart = value.join("/");
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.processException.accessories.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      deleteFile(index) {
        this.processException.accessories.splice(index, 1);
      },
      oneDelete(index) {
        this.processException.processExceptionMaterialVOS.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },

      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        if (hours >= 0 && hours <= 9) {
          hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
          seconds = "0" + seconds;
        }
        console.log(date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds);
        this.processException.createTime = date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds;
      },
      selectNameByNo() {
        if (this.processException.materialNo.length > 0) {
          let params = {
            no: this.processException.materialNo,
          };
          this.$http
            .get("basic", "baseMaterials/selectNameByNo", params)
            .then((res) => {
              this.processException.materialName = res;
            });
        }
      },
      customerAdd(row) {
        console.log(row);
        this.processException.customerName = row.customerName;
        this.processException.customerId = row.customerID;
      },

      selectHandle(row) {
        this.processException.handleId = row.systemUserID;
        this.processException.handleName = row.employeeName;
      },

      selectQualityDirecter(row) {
        this.processException.qualityDirecterId = row.systemUserID;
        this.processException.qualityDirecterName = row.employeeName;
      },

      addMaterial(row) {
        console.log(row);
        let material = {
          materialId: row.id,
          materialNo: row.no,
          materialName: row.name,
          badNum: 1,
        };
        this.processException.processExceptionMaterialVOS.push(material);
      },

      supplierSelect(row) {
        console.log("供应", row);
        this.processException.supplierId = row.pkid;
        this.processException.supplierName = row.name;
      },
      getCustomerName() {
        if (this.processException.factoryNo) {
          console.log(this.processException.factoryNo);
          let params = {
            pcNo: this.processException.factoryNo,
          };
          this.$http.get("basic", "sd/so/selectByPcNo", params).then((res) => {
            console.log(res);
            this.processException.customerName = res.data.customerName;
            this.processException.customerId = res.data.customerID;
          });
        }
      },
      departmentSelect(row) {
        console.log("部门", row);
        this.processException.responsibleDepartment = row.departmentName;
      },
      selectResponsible(row) {
        this.processException.responsibleId = row.systemUserID;
        this.processException.responsibleName = row.employeeName;
      },
      deleteRow(index) {
        this.processException.processExceptionMaterialVOS.splice(index, 1);
      },

      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            let isSubmit = false;
            if (this.processException.pkid > 0) {
              this.$http.put("basic", `processExceptions/update_submit/${isSubmit}`, this.processException).then((res) => {
                this.$emit("save-success");
                this.$message.success("保存成功");
                this.saveLoading = false;
                this.dialogVisible = false;
              }).catch(() => {
                this.saveLoading = false;
              });
            } else {
              this.$http.post("basic", `processExceptions/insert_submit/${isSubmit}`, this.processException).then((res) => {
                this.$emit("save-success");
                this.$message.success("保存成功");
                this.saveLoading = false;
                this.dialogVisible = false;
              }).catch(() => {
                this.saveLoading = false;
              });
            }
          }
        });


      },
      handleSaveByBack() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            let isSubmit = false;
            this.$http.put("basic", "processExceptions/updateByBack", this.processException).then((res) => {
              this.$emit("save-success");
              this.$message.success("保存成功");
              this.saveLoading = false;
              this.dialogVisible = false;
            }).catch(() => {
              this.saveLoading = false;
            });
          }
        });


      },
      handleSubmit() {
        this.submitLoading = true;
        let isSubmit = true;
        if (this.processException.pkid > 0) {
          this.$http.put("basic", `processExceptions/update_submit/${isSubmit}`, this.processException).then((res) => {
            this.$emit("save-success");
            this.$message.success("提交成功");
            this.submitLoading = false;
            this.dialogVisible = false;
          }).catch(() => {
            this.submitLoading = false;
          });
        } else {
          this.$http.post("basic", `processExceptions/insert_submit/${isSubmit}`, this.processException).then((res) => {
            this.$emit("save-success");
            this.$message.success("提交成功");
            this.submitLoading = false;
            this.dialogVisible = false;
          }).catch(() => {
            this.submitLoading = false;
          });
        }

      },
    },
  };
</script>

<style lang="scss" scoped>
.form {
  ::v-deep {
    .el-textarea__inner,
    .el-input__inner {
      background: #fff9c4;
    }
  }
}

.processException-edit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.processException-edit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.processException-edit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.processException-edit .el-divider--horizontal {
  margin: 10px 0;
}

.processException-edit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>